import { LinearProgress, LinearProgressProps } from '@mui/material'
import React, { FC } from 'react'

export type C1LinearProgressProps = LinearProgressProps

export const C1LinearProgress: FC<C1LinearProgressProps> = (props) => <LinearProgress {...props} />
